import { MantineProvider } from '@mantine/core'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import { useTheme } from '@/lib/theme-context'
import { mantineTheme } from '@/lib/mantine-theme'
import type { ReactNode } from 'react'

export function MantineAppProvider({ children }: { children: ReactNode }) {
  const { theme } = useTheme()

  return (
    <MantineProvider theme={mantineTheme} forceColorScheme={theme} defaultColorScheme={theme}>
        <ModalsProvider labels={{ confirm: 'Подтвердить', cancel: 'Отмена' }}>
          <Notifications position="top-right" zIndex={5000} limit={5} />
        {children}
      </ModalsProvider>
    </MantineProvider>
  )
}
